import { combineReducers } from 'redux'
import types from 'actions/types'
import activities from './activities'
import selected from './selected'

export const saving = (state = false, action) => {
  switch (action.type) {
    case types.DIARY_EDIT_ACTIVITY_ATTEMPT:
    case types.DIARY_ADD_ACTIVITY_ATTEMPT:
    case types.DIARY_DELETE_ACTIVITY_ATTEMPT: return true
    case types.DIARY_EDIT_ACTIVITY_SUCCESS:
    case types.DIARY_EDIT_ACTIVITY_FAILURE:
    case types.DIARY_ADD_ACTIVITY_SUCCESS:
    case types.DIARY_ADD_ACTIVITY_FAILURE:
    case types.DIARY_DELETE_ACTIVITY_SUCCESS:
    case types.DIARY_DELETE_ACTIVITY_FAILURE: return false
    default: return state
  }
}

export const adding = (state = false, action) => {
  switch (action.type) {
    case types.DIARY_ADD_ACTIVITY_ATTEMPT: return true
    case types.DIARY_ADD_ACTIVITY_SUCCESS:
    case types.DIARY_ADD_ACTIVITY_FAILURE: return false
    default: return state
  }
}

export const updating = (state = false, action) => {
  switch (action.type) {
    case types.DIARY_EDIT_ACTIVITY_ATTEMPT: return true
    case types.DIARY_EDIT_ACTIVITY_SUCCESS:
    case types.DIARY_EDIT_ACTIVITY_FAILURE: return false
    default: return state
  }
}

export default combineReducers({
  saving,
  adding,
  updating,
  activities,
  selected,
})
